import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import userApi from "@/lib/userApi";
import { formatApiErrorDetail } from "@/lib/api";
import { useAppAuth } from "@/context/AppAuthContext";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refresh, user } = useAppAuth();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) {
      setState("error");
      setMsg("Липсва код за потвърждение.");
      return;
    }
    userApi
      .post("/account/verify-email", { token })
      .then((r) => {
        setState("ok");
        setMsg(r.data.message || "Имейлът е потвърден.");
        refresh();
      })
      .catch((err) => {
        setState("error");
        setMsg(formatApiErrorDetail(err.response?.data?.detail) || "Неуспешно потвърждение.");
      });
  }, [token, refresh]);

  return (
    <Layout showTicker={false}>
      <Seo title="Потвърждение на имейл" noindex />
      <div className="mx-auto max-w-md px-4 py-20 text-center" data-testid="verify-email-page">
        {state === "loading" && (
          <><Loader2 className="mx-auto h-10 w-10 animate-spin text-primary" /><p className="mt-4 text-slate-500">Потвърждаваме имейла Ви…</p></>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="mx-auto h-14 w-14 text-green-600" data-testid="verify-email-success" />
            <h1 className="mt-5 font-display text-2xl font-extrabold text-slate-900">Готово!</h1>
            <p className="mt-2 text-slate-600">{msg}</p>
            <div className="mt-6 flex justify-center gap-3">
              <Link to="/publikuvai-obyava" className="rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-white hover:bg-[#0041A8]">Публикувай обява</Link>
              <Link to={user ? "/profil" : "/vhod"} className="rounded-full border border-slate-200 px-5 py-2.5 text-sm font-semibold text-slate-700 hover:border-primary hover:text-primary">{user ? "Към профила" : "Вход"}</Link>
            </div>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="mx-auto h-14 w-14 text-red-500" data-testid="verify-email-error" />
            <h1 className="mt-5 font-display text-2xl font-extrabold text-slate-900">Възникна проблем</h1>
            <p className="mt-2 text-slate-600">{msg}</p>
            <div className="mt-6">
              <Link to={user ? "/profil" : "/vhod"} className="rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-white hover:bg-[#0041A8]">
                {user ? "Изпрати нова връзка от профила" : "Вход"}
              </Link>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
